import { AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
    selector: '[tidySize]',
    standalone: false
})
export class TidySizeDirective implements AfterViewInit {

  constructor(
    private el: ElementRef,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document
    ) { }

  @Input() tidySize = '';
  @Input() breakOffset = 1050;
  readonly windowWidth = this.document.defaultView?.innerWidth || 1024;

  ngAfterViewInit() {
    this.render(this.windowWidth);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.render(event?.target?.innerWidth);
  }

  render(wWidth) {
    if (!this.el) {
      return;
    }
    if (wWidth < this.breakOffset) {
      this.renderer2.setStyle(this.el.nativeElement, 'width', 'inherit');
      this.renderer2.setStyle(this.el.nativeElement, 'max-width', 'inherit');
    } else {
      const sizeCalc = `calc(calc(${this.tidySize} / 10) * 100%)`;

      ['width', 'max-width', 'flex'].forEach(attr => {
        this.renderer2.setStyle(this.el.nativeElement, attr, sizeCalc);
      });
    }
  }

}
